import HttpRequest from './http_request'

class CentralProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_CENTRAL_API_URL)
  }

  async getServertime() {
    const { data } = await this.get('/', {
      function: 'get-server-time',
    })
    return data
  }

  async getRegistrarUserAccount() {
    const { data } = await this.get('user/', {
      function: 'get-registrar-user-account',
    })
    return data
  }
  // ############  gen student id
  async getRegistrarFaculty() {
    const { data } = await this.get('faculty/', {
      function: 'get-registrar-faculty',
    })
    return data
  }

  async getRegistrarDepartment(faculty_id, department_id) {
    const { data } = await this.get('department/', {
      function: 'get-registrar-department',
      faculty_id,
      department_id,
    })
    return data
  }

  async getRegistrarCurriculum(level_id, faculty_id, curriculum_id, department_id) {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }
}

export default CentralProvider